import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { saveDatosNomina } from "../../../../../redux/actions/denuncia";
import { convertDateTimeToNet } from "../../../../../util/datetime";
import HeaderForm from "../../../../commons/labels/HeaderForm";
import CircularLoading from "../../../../commons/loading/CircularLoading";
import DatosNominaForm from "./DatosNominaForm";

const initialValues = {
  fechaIngresoEmpleador: null,
  agropecuario: false,
  domestica: false,
  categoriaDomestica: "",
  fechaIngresoDependencia: null,
  establecimiento: "",
  puestoTrabajo: "",
  turno: "",
  horaDesde: null,
  horaHasta: null,
};

const DatosNominaContainer = ({ nextForm }) => {
  const dispatch = useDispatch();

  const nomina = useSelector((state) => state.denuncia.nomina);

  const [formModel, setFormModel] = useState(null);

  const handleSubmit = (data) => {
    const model = {
      ...data,
      fechaIngresoEmpleador: convertDateTimeToNet(data.fechaIngresoEmpleador),
      fechaIngresoDependencia: convertDateTimeToNet(
        data.fechaIngresoDependencia
      ),
      horaDesde: convertDateTimeToNet(data.horaDesde),
      horaHasta: convertDateTimeToNet(data.horaHasta),
    };
    dispatch(saveDatosNomina(model));
    nextForm("DatosDenunciaForm");
  };

  useEffect(() => {
    if (nomina.data) {
      setFormModel(() => ({
        ...initialValues,
        fechaIngresoEmpleador:
          nomina.data.fechaIngresoEmpleador?.valor ||
          initialValues.fechaIngresoEmpleador,
        agropecuario:
          nomina.data.agropecuario?.valor || initialValues.agropecuario,
        domestica: nomina.data.domestica?.valor || initialValues.domestica,
        categoriaDomestica:
          nomina.data.categoriaDomestica?.valor ||
          initialValues.categoriaDomestica,
        fechaIngresoDependencia:
          nomina.data.fechaIngresoDependencia?.valor ||
          initialValues.fechaIngresoDependencia,
        establecimiento:
          nomina.data.establecimiento?.valor || initialValues.establecimiento,
        puestoTrabajo:
          nomina.data.puestoTrabajo?.valor || initialValues.puestoTrabajo,
        turno: nomina.data.turno?.valor || initialValues.turno,
        horaDesde: new Date(nomina.data.horaDesde?.valor) || initialValues.horaDesde,
        horaHasta: new Date(nomina.data.horaHasta?.valor) || initialValues.horaHasta,
      }));
    }
  }, [nomina.data]);

  return (
    <>
      <HeaderForm title="Datos de la Nómina" />
      {formModel != null ? (
        <DatosNominaForm
          handleSubmit={handleSubmit}
          model={formModel}
          fields={nomina.data}
        />
      ) : (
        <CircularLoading />
      )}
    </>
  );
};

export default DatosNominaContainer;
